import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { useRef, useState } from 'react';

import Button from 'shopper/components/Button';
import Icon from 'shopper/components/Icon';

import { sendEvent } from 'lib/gtag';

const Dropdown = dynamic(() => import('./Dropdown'), { ssr: false });

const Share = ({ gaEventCategory, offerPrice, offerPriceType, offerTitle }) => {
  const openerRef = useRef(null);
  const [isOpen, setOpen] = useState(false);

  const onToggleDropdown = () => {
    sendEvent({
      action: 'share_offer',
      category: gaEventCategory,
    });
    setOpen((prevState) => !prevState);
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <div className="relative h-fit">
      <Button
        ref={openerRef}
        aria-label="Compartilhar"
        className="size-9 rounded-full !border !border-neutral-high-300 !bg-neutral-high-100/90 !p-0 backdrop-blur-sm min-size-9 dark:!border-neutral-high-500 dark:!bg-neutral-low-400/90 [&>svg]:text-success-300 dark:[&>svg]:text-success-300"
        icon={<Icon name="whatsapp" />}
        size="size4"
        type="primary-ghost"
        onClick={onToggleDropdown}
      />
      {isOpen && (
        <Dropdown
          gaEventCategory={gaEventCategory}
          offerPrice={offerPrice}
          offerPriceType={offerPriceType}
          offerTitle={offerTitle}
          openerRef={openerRef}
          onClose={onClose}
        />
      )}
    </div>
  );
};

Share.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  offerPrice: PropTypes.number.isRequired,
  offerPriceType: PropTypes.string.isRequired,
  offerTitle: PropTypes.string.isRequired,
};

export default Share;
